(function () { if (!LN.Core) throw new Error("LN.Core missing"); })();

(function (Helper, Config, Model, $) {
    'use strict';

    // ==================================================
    // Valida si esta vacio cualquier tipo de dato
    // Params : {obj} || {arr} || {str}
    // ==================================================
    Helper.isEmpty = function (obj) {
        if (obj == null) return true;
        if (obj.length > 0) return false;
        if (obj.length === 0) return true;
        for (var key in obj) {
            if (hasOwnProperty.call(obj, key)) return false;
        }
        return true;
    }

    // ==================================================
    // Lee el valor de una cookie
    // Params : {str}
    // ==================================================   
    Helper.readCookie = function (name) {
        logger && logger.debug('readCookie [' + name + ']');
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    // ==================================================
    // Borra todas las cookies
    // ==================================================   
    Helper.deleteAllCookies = function () {
        logger && logger.debug('deleteAllCookies');
        var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            if (Config.DiccionarioCookiesAGuardar.indexOf(name.trim()) > -1) {
                if (document.domain === 'localhost') {
                    //console.log("Delete Cookie - Name : " + name);
                    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
                } else {
                    //console.log("Delete Cookie - Name : " + name);
                    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=" + Config.dominioCookie;
                }
            }
        }
    }
    // ==================================================
    // Limpia el modelo, cookies y resetea parametros de URL
    // ==================================================   
    Helper.resetAll = function (cb) {
        var token = Helper.readCookie("token");
        var usuario_detalle_guid = Helper.readCookie("usuario%5Fdetalle%5Fguid");
        var cookieLogin = Helper.readCookie("cookieLogin");

        $(':input').val('');
        for (var index in Model.Usuario) {
            Model.Usuario[index] = '';
        }
        Helper.deleteAllCookies();
        if (!(Helper.isEmpty(usuario_detalle_guid) || Helper.isEmpty(cookieLogin) || Helper.isEmpty(token))) {
            Model.Usuario.HayCookie = 1;
        }
        Model.Usuario.SitioId = Model.Window.SitioId;
        cb && cb();
    }

})(LN.Helper, LN.Config, LN.Model, jQuery);


// WEBPACK FOOTER //
// ./Statics/scripts/login/core/helperLogout.js